import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    group: '',
    gender: '',
    created_at_from: '',
    created_at_to: '',
    birthday_from: '',
    birthday_to: '',
  },
  program_student: null
}

export const studentsUI = createSlice({
  name: 'studentsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setGender: (state, { payload }) => {
      state.tableFilters.gender = payload
    },
    setCreatedAtFromDate: (state, { payload }) => {
      state.tableFilters.created_at_from = payload
    },
    setCreatedAtToDate: (state, { payload }) => {
      state.tableFilters.created_at_to = payload
    },
    setBirthdayFromDate: (state, { payload }) => {
      state.tableFilters.birthday_from = payload
    },
    setBirthdayToDate: (state, { payload }) => {
      state.tableFilters.birthday_to = payload
    },
    setProgramStudent: (state, { payload }) => {
      state.program_student = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setGroup,
  setGender,
  setCreatedAtFromDate,
  setCreatedAtToDate,
  setBirthdayFromDate,
  setBirthdayToDate,
  setProgramStudent,
  trackActiveFilters,
  clearAllFilters,
} = studentsUI.actions

export default studentsUI.reducer
